<form
  #form="ngForm"
  novalidate
  data-ping-host
>
  @if (stockStore.vm().notInUseTanks?.length) {
    <div id="tanksNotInUse">
      <h3 class="text-md py-4 font-bold">Not In Use</h3>
      <re-stock-table
        [tabId]="tabId"
        [sectionId]="sectionId"
        [data]="stockStore.vm().notInUseTanks"
        [fieldId]="fieldId"
        [columns]="columns"
        [required]="stockStore.options().tankSounding.value ?? false"
      ></re-stock-table>
    </div>
  }
</form>
